import React from 'react';

interface WeekDayProps {
  day: string;
  className?: string;
}

export const WeekDay: React.FC<WeekDayProps> = ({ day, className = '' }) => {
  return (
    <div
      className={`ui-flex ui-h-control-xs ui-w-control-xs ui-select-none ui-items-center ui-justify-center ui-text-body-xs-medium ui-font-body-xs-medium ui-leading-body-xs-medium ui-tracking-body-xs ui-text-tertiary ${className}`}
      role="columnheader"
      aria-label={`Día ${day}`}
    >
      {day}
    </div>
  );
};
